function initQuote() {
	// Select modal triggers and modals
	var modalTrigger = document.querySelector("#quote-link");
	var modal = document.querySelector("#quote-modal");
	
	// Event listener for opening the modal
	if (modalTrigger) {
	  modalTrigger.addEventListener("click", function(event) {
		event.preventDefault();
		if (modal) {
		  modal.style.display = "flex";
		  document.body.classList.add("no-scroll"); // Add no-scroll class to body
		}
	  });
	}
  
	// Event listener for closing the modal
	if (modal) {
	  var closeModal = modal.querySelector(".modal-box-close");
	  if (closeModal) {
		closeModal.addEventListener("click", function() {
		  modal.style.display = "none";
		  document.body.classList.remove("no-scroll"); // Remove no-scroll class from body
		});
	  }
  
	  // Close modal if clicking outside of the modal content
	  window.addEventListener("click", function(event) {
		if (event.target === modal) {
		  modal.style.display = "none";
		  document.body.classList.remove("no-scroll"); // Remove no-scroll class from body
		}
	  });
	}
  }
  
  // Export the function
  export { initQuote };
  
  // Call the function when the DOM is ready
  document.addEventListener("DOMContentLoaded", function() {
	initQuote();
  });
  